/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export const OrderFulfillmentStatus = {
	NotNeeded: 'NOT_NEEDED',
	NotFulfilled: 'NOT_FULFILLED',
	PartiallyFulfilled: 'PARTIALLY_FULFILLED',
	Fulfilled: 'FULFILLED'
} as const
export type OrderFulfillmentStatusType = (typeof OrderFulfillmentStatus)[keyof typeof OrderFulfillmentStatus]
export type OrderListItem = {
	uuid: string
	displayId: string
	date: number
	salesChannel: string
	paymentStatus: CommonTypes.OrderPaymentStatusType
	fulfillmentStatus: OrderFulfillmentStatusType
	fulfillmentProvider?: CommonTypes.FulfillmentProviderType
	pointOfSale?: string
	total: CommonTypes.Amount
	currencyCode: string
	items: {
		name: string
		imageUrl?: string
	}[]
	transactions: {
		paymentMethod: string
		total: CommonTypes.Amount
	}[]
	pointsEarned?: number
	pointsUsed?: number
}
export const OrderType = {
	Internal: 'INTERNAL',
	External: 'EXTERNAL'
} as const
export type OrderTypeType = (typeof OrderType)[keyof typeof OrderType]
export const OrderStatus = {
	Draft: 'DRAFT',
	Completed: 'COMPLETED',
	Canceled: 'CANCELED'
} as const
export type OrderStatusType = (typeof OrderStatus)[keyof typeof OrderStatus]
export type QuantityInfo = {
	quantity: number
} & (
	| {
			pricingMethod: 'PER_UNIT'
	  }
	| {
			pricingMethod: 'PRICE_EMBEDDED'
			price: CommonTypes.Amount
	  }
	| {
			pricingMethod: 'PER_WEIGHT' | 'WEIGHT_EMBEDDED'
			weight: number
	  }
)
export type OrderItemFee = {
	uuid: string
	name: string
	quantity: number
	unitPrice: CommonTypes.Amount
	totalPrice: CommonTypes.Amount
}
export type OrderItemDiscount = {
	uuid: string
	name: string
	amount: CommonTypes.Amount
}
export type OrderItem = {
	uuid: string
	productUuid?: string
	variantName: string
	variantThumbnail: string
	quantityInfo: QuantityInfo
	unitPrice?: CommonTypes.Amount
	totalPrice: CommonTypes.Amount
	itemTotal?: CommonTypes.Amount
	fees: OrderItemFee[]
	discounts?: OrderItemDiscount[]
	pointsEarned?: number
	refundedQuantity?: number
	refundableQuantity?: number
	promotionLocked?: boolean
}
export type OrderItemGroup = {
	uuid: string
	items: OrderItem[]
	totalPrice?: CommonTypes.Amount
	shouldOverridePrice?: boolean
	name?: string
}
export const TransactionType = {
	Capture: 'CAPTURE',
	Refund: 'REFUND'
} as const
export type TransactionTypeType = (typeof TransactionType)[keyof typeof TransactionType]
export const TransactionStatus = {
	Success: 'SUCCESS',
	Failed: 'FAILED',
	Pending: 'PENDING'
} as const
export type TransactionStatusType = (typeof TransactionStatus)[keyof typeof TransactionStatus]
export type OrderRefund = {
	uuid: string
	sequenceNumber: string
	date: number
	amount: CommonTypes.Amount
	type: 'REFUND'
	status: TransactionStatusType
	provider: CommonTypes.PaymentProviderType
	description?: string
}
export type OrderTransaction = {
	uuid: string
	sequenceNumber: string
	date: number
	currencyCode: string
	amount: CommonTypes.Amount
	type: 'CAPTURE'
	status: TransactionStatusType
	provider: CommonTypes.PaymentProviderType
	maskedPan?: string
	bin?: string
	lastDigits?: string
	cardType?: string
	cardIssuerName?: string
	totalRefunded: CommonTypes.Amount
	refundableAmount: CommonTypes.Amount
	refunds: OrderRefund[]
	description?: string
}
export type GiftCardRedemption = {
	uuid: string
	name: string
	amount: CommonTypes.Amount
}
export const BagCheckStatus = {
	Created: 'CREATED',
	Approved: 'APPROVED',
	Rejected: 'REJECTED'
} as const
export type BagCheckStatusType = (typeof BagCheckStatus)[keyof typeof BagCheckStatus]
export type BagCheckListItem = {
	uuid: string
	createdAt: number
	finishedAt: number
	status: BagCheckStatusType
	userName: string
}
export type SandStarOrderInfo = {
	cloudReview: 'Y' | 'N'
	topVideoUrl?: string
	orderNo?: string
	machineId?: string
	machineName?: string
	abnormalReason?: string
}
export type OrderMetadataJson = {
	sandstar?: SandStarOrderInfo
}
export type Order = {
	uuid: string
	displayId: string
	type: OrderTypeType
	status: 'COMPLETED' | 'CANCELED'
	bagCheckStatus: CommonTypes.OrderBagCheckStatusType
	checkoutStatus: CommonTypes.OrderCheckoutStatusType
	date: number
	salesChannel: string
	pointOfSale?: string
	paymentStatus: CommonTypes.OrderPaymentStatusType
	currencyCode: string
	fulfillmentProvider?: CommonTypes.FulfillmentProviderType
	fulfillmentStatus: OrderFulfillmentStatusType
	itemGroups: OrderItemGroup[]
	orderTotal: CommonTypes.Amount
	transactionNetAmount: CommonTypes.Amount
	outstandingAmount: CommonTypes.Amount
	refundableAmount?: CommonTypes.Amount
	refunds?: OrderRefund[]
	transactions: OrderTransaction[]
	giftCardRedemptions: GiftCardRedemption[]
	giftCardTotal: CommonTypes.Amount
	taxTotal: CommonTypes.Amount
	taxLines: {
		code: string
		total: CommonTypes.Amount
	}[]
	bagChecks: BagCheckListItem[]
	pointsEarned?: number
	customer?: {
		uuid: string
		firstName?: string
		lastName?: string
		email?: string
		phone?: string
	}
	loyaltyCard?: {
		uuid: string
		name: string
		cardNumber: string
	}
	metadataJson?: OrderMetadataJson
}
export type BagCheck = {
	uuid: string
	status: BagCheckStatusType
	order: Order
	scannedItemMapping: {
		itemId?: string
		itemQuantity?: number
		scannedItemId?: string
		scannedQuantity: number
		scannedAt?: number
	}[]
	itemsNotInCart: OrderItem[]
}

export const zOrderFulfillmentStatus = z.enum(['NOT_NEEDED', 'NOT_FULFILLED', 'PARTIALLY_FULFILLED', 'FULFILLED'])
export const zOrderListItem = z.object({
	uuid: z.string(),
	displayId: z.string(),
	date: z.number(),
	salesChannel: z.string(),
	paymentStatus: CommonTypes.zOrderPaymentStatus,
	fulfillmentStatus: zOrderFulfillmentStatus,
	fulfillmentProvider: CommonTypes.zFulfillmentProvider.optional(),
	pointOfSale: z.string().optional(),
	total: CommonTypes.zAmount,
	currencyCode: z.string(),
	items: z.array(
		z.object({
			name: z.string(),
			imageUrl: z.string().optional()
		})
	),
	transactions: z.array(
		z.object({
			paymentMethod: z.string(),
			total: CommonTypes.zAmount
		})
	),
	pointsEarned: z.number().optional(),
	pointsUsed: z.number().optional()
})
export const zOrderType = z.enum(['INTERNAL', 'EXTERNAL'])
export const zOrderStatus = z.enum(['DRAFT', 'COMPLETED', 'CANCELED'])
export const zQuantityInfo = z.intersection(
	z.object({
		quantity: z.number()
	}),
	z.union([
		z.object({
			pricingMethod: z.enum(['PER_UNIT'])
		}),
		z.object({
			pricingMethod: z.enum(['PRICE_EMBEDDED']),
			price: CommonTypes.zAmount
		}),
		z.object({
			pricingMethod: z.enum(['PER_WEIGHT', 'WEIGHT_EMBEDDED']),
			weight: z.number()
		})
	])
)
export const zOrderItemFee = z.object({
	uuid: z.string(),
	name: z.string(),
	quantity: z.number(),
	unitPrice: CommonTypes.zAmount,
	totalPrice: CommonTypes.zAmount
})
export const zOrderItemDiscount = z.object({
	uuid: z.string(),
	name: z.string(),
	amount: CommonTypes.zAmount
})
export const zOrderItem = z.object({
	uuid: z.string(),
	productUuid: z.string().optional(),
	variantName: z.string(),
	variantThumbnail: z.string(),
	quantityInfo: zQuantityInfo,
	unitPrice: CommonTypes.zAmount.optional().nullable(),
	totalPrice: CommonTypes.zAmount,
	itemTotal: CommonTypes.zAmount.optional().nullable(),
	fees: z.array(zOrderItemFee),
	discounts: z.array(zOrderItemDiscount).optional(),
	pointsEarned: z.number().optional(),
	refundedQuantity: z.number().optional(),
	refundableQuantity: z.number().optional(),
	promotionLocked: z.boolean().optional()
})
export const zOrderItemGroup = z.object({
	uuid: z.string(),
	items: z.array(zOrderItem),
	totalPrice: CommonTypes.zAmount.optional().nullable(),
	shouldOverridePrice: z.boolean().optional(),
	name: z.string().optional()
})
export const zTransactionType = z.enum(['CAPTURE', 'REFUND'])
export const zTransactionStatus = z.enum(['SUCCESS', 'FAILED', 'PENDING'])
export const zOrderRefund = z.object({
	uuid: z.string(),
	sequenceNumber: z.string(),
	date: z.number(),
	amount: CommonTypes.zAmount,
	type: z.enum(['REFUND']),
	status: zTransactionStatus,
	provider: CommonTypes.zPaymentProvider,
	description: z.string().optional()
})
export const zOrderTransaction = z.object({
	uuid: z.string(),
	sequenceNumber: z.string(),
	date: z.number(),
	currencyCode: z.string(),
	amount: CommonTypes.zAmount,
	type: z.enum(['CAPTURE']),
	status: zTransactionStatus,
	provider: CommonTypes.zPaymentProvider,
	maskedPan: z.string().optional(),
	bin: z.string().optional(),
	lastDigits: z.string().optional(),
	cardType: z.string().optional(),
	cardIssuerName: z.string().optional(),
	totalRefunded: CommonTypes.zAmount,
	refundableAmount: CommonTypes.zAmount,
	refunds: z.array(zOrderRefund),
	description: z.string().optional()
})
export const zGiftCardRedemption = z.object({
	uuid: z.string(),
	name: z.string(),
	amount: CommonTypes.zAmount
})
export const zBagCheckStatus = z.enum(['CREATED', 'APPROVED', 'REJECTED'])
export const zBagCheckListItem = z.object({
	uuid: z.string(),
	createdAt: z.number(),
	finishedAt: z.number(),
	status: zBagCheckStatus,
	userName: z.string()
})
export const zSandStarOrderInfo = z.object({
	cloudReview: z.enum(['Y', 'N']),
	topVideoUrl: z.string().optional(),
	orderNo: z.string().optional(),
	machineId: z.string().optional(),
	machineName: z.string().optional(),
	abnormalReason: z.string().optional()
})
export const zOrderMetadataJson = z.object({
	sandstar: zSandStarOrderInfo.optional().nullable()
})
export const zOrder = z.object({
	uuid: z.string(),
	displayId: z.string(),
	type: zOrderType,
	status: z.enum(['COMPLETED', 'CANCELED']),
	bagCheckStatus: CommonTypes.zOrderBagCheckStatus,
	checkoutStatus: CommonTypes.zOrderCheckoutStatus,
	date: z.number(),
	salesChannel: z.string(),
	pointOfSale: z.string().optional(),
	paymentStatus: CommonTypes.zOrderPaymentStatus,
	currencyCode: z.string(),
	fulfillmentProvider: CommonTypes.zFulfillmentProvider.optional(),
	fulfillmentStatus: zOrderFulfillmentStatus,
	itemGroups: z.array(zOrderItemGroup),
	orderTotal: CommonTypes.zAmount,
	transactionNetAmount: CommonTypes.zAmount,
	outstandingAmount: CommonTypes.zAmount,
	refundableAmount: CommonTypes.zAmount.optional().nullable(),
	refunds: z.array(zOrderRefund).optional(),
	transactions: z.array(zOrderTransaction),
	giftCardRedemptions: z.array(zGiftCardRedemption),
	giftCardTotal: CommonTypes.zAmount,
	taxTotal: CommonTypes.zAmount,
	taxLines: z.array(
		z.object({
			code: z.string(),
			total: CommonTypes.zAmount
		})
	),
	bagChecks: z.array(zBagCheckListItem),
	pointsEarned: z.number().optional(),
	customer: z
		.object({
			uuid: z.string(),
			firstName: z.string().optional(),
			lastName: z.string().optional(),
			email: z.string().optional(),
			phone: z.string().optional()
		})
		.optional(),
	loyaltyCard: z
		.object({
			uuid: z.string(),
			name: z.string(),
			cardNumber: z.string()
		})
		.optional(),
	metadataJson: zOrderMetadataJson.optional().nullable()
})
export const zBagCheck = z.object({
	uuid: z.string(),
	status: zBagCheckStatus,
	order: zOrder,
	scannedItemMapping: z.array(
		z.object({
			itemId: z.string().optional(),
			itemQuantity: z.number().optional(),
			scannedItemId: z.string().optional(),
			scannedQuantity: z.number(),
			scannedAt: z.number().optional()
		})
	),
	itemsNotInCart: z.array(zOrderItem)
})
